var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"button button-round button-100",class:Object.assign({}, _vm.colorClass,
    {'is-loading': _vm.loading,
    'with-icon': _vm.withIcon,
    'full-width': _vm.fullWidth}),attrs:{"type":_vm.type,"disabled":_vm.disabled || _vm.loading,"data-testid":_vm.dataTestid},on:{"click":function($event){return _vm.$emit('click')}}},[(!_vm.loading)?_vm._t("default"):_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }